import { render, staticRenderFns } from "./Specification2Tab.vue?vue&type=template&id=0deabe4d&"
import script from "./Specification2Tab.vue?vue&type=script&lang=ts&"
export * from "./Specification2Tab.vue?vue&type=script&lang=ts&"
import style0 from "./Specification2Tab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports